import { createAction, props } from '@ngrx/store';
import { EventModel } from '../models/events.model';
import {
  IEventsCommonProps,
  IUpsertEventPayload,
} from '../repositories/IEvents.repository';

export enum EventsActionTypes {
  getEventsBegin = '[Calendar] Get Events begin',
  getEventsSuccess = '[Calendar] Get Events success',
  getEventsFail = '[Calendar] Get Events failure',

  createEventBegin = '[Calendar] Create Event begin',
  createEventSuccess = '[Calendar] Create Event success',
  createEventFail = '[Calendar] Create Event failure',

  updateEventBegin = '[Calendar] Update Event begin',
  updateEventSuccess = '[Calendar] Update Event success',
  updateEventFail = '[Calendar] Update Event failure',

  deleteEventBegin = '[Calendar] Delete Event begin',
  deleteEventSuccess = '[Calendar] Delete Event success',
  deleteEventFail = '[Calendar] Delete Event failure',

  selectEvent = '[Calendar] Select Event',

  clearEventsSuccessErrorData = '[Calendar] Clear Events Success Error Data',
}

// GET
export const getEventsBeginAction = createAction(
  EventsActionTypes.getEventsBegin
);

export const getEventSuccessAction = createAction(
  EventsActionTypes.getEventsSuccess,
  props<{ events: EventModel[] }>()
);

export const getEventFailAction = createAction(
  EventsActionTypes.getEventsFail,
  props<{ errors: any }>()
);

// CREATE
export const createEventBeginAction = createAction(
  EventsActionTypes.createEventBegin,
  props<{ payload: EventModel }>()
);

export const createEventSuccessAction = createAction(
  EventsActionTypes.createEventSuccess,
  props<{ payload: EventModel[]; eventId: number }>()
);

export const createEventFailAction = createAction(
  EventsActionTypes.createEventFail,
  props<{ errors: any }>()
);

// UPDATE
export const updateEventBeginAction = createAction(
  EventsActionTypes.updateEventBegin,
  props<{ payload: EventModel }>()
);

export const updateEventSuccessAction = createAction(
  EventsActionTypes.updateEventSuccess,
  props<{ event: EventModel }>()
);

export const updateEventFailAction = createAction(
  EventsActionTypes.updateEventFail,
  props<{ errors: any }>()
);

// DELETE
export const deleteEventBeginAction = createAction(
  EventsActionTypes.deleteEventBegin,
  props<{ eventId: number }>()
);

export const deleteEventSuccessAction = createAction(
  EventsActionTypes.deleteEventSuccess,
  props<{ eventId: number }>()
);

export const deleteEventFailAction = createAction(
  EventsActionTypes.deleteEventFail,
  props<{ errors: any }>()
);

export const selectEventAction = createAction(
  EventsActionTypes.selectEvent,
  props<{ eventId: number }>()
);

export const clearEventsSuccessErrorDataAction = createAction(
  EventsActionTypes.clearEventsSuccessErrorData
);
